export const LS_CART_KEY = 'guestCartItems';
export const LS_AI_CHAT_HISTORY = 'chatThreads';
